import React from 'react'
import PropTypes from 'prop-types'
import Logo from '@/assets/images/peppermint.svg'

function GuestLayout({ children }) {
  return (
    <div>
      <div className="h-16 bg-white shadow-sm px-10 flex justify-between items-center">
        <img src={Logo} alt="logo" />
        <div className=" text-primary text-lg font-medium" />
      </div>
      {children}
    </div>
  )
}

GuestLayout.propTypes = {
  children: PropTypes.any.isRequired,
}

export default GuestLayout
